/*
 * @Descripttion:
 * @version:
 * @Author: lxh
 * @Date: 2022-08-16 19:35:25
 */
import { createApp } from "vue";
import router from "./router/router";
import App from "./App.vue";
import antd from "ant-design-vue";
//import "ant-design-vue/dist/antd.css";

createApp(App).use(router).use(antd).mount("#app");
